import React from "react";
import Header from "./Header";
import Body from "./Body";
import Design from "./Design";
import Footer from "./Footer";
import About from "./About";

function App() {
    return (
        <div className="body">
            <Header/>
            <Body />
            <About/>
            <Design/>
            <Footer/>
        </div>
    );
}


export default App